import React, { useEffect, useRef, useState } from 'react';
import { addData, deleteFileByUrl, getData, handleFireBaseUpload, updateDoc } from '../Firebase/firestore';
import { db } from '../firebase';

import './resources.css'
import './embroidery.css'
import './main.css'
import './tuxedo.css'
import sh from '../assets/search.png'

const normalizeKey = (v) => String(v || '').trim().toLowerCase();

const GARMENT_PARTS = {
  coat: ['base', 'lapel', 'collar', 'sleeve', 'back', 'flap'],
  shirt: ['base', 'collar', 'sleeve', 'back', 'pocket', 'flap'],
  kurta: ['base', 'collar', 'sleeve', 'back', 'pocket', 'flap'],
  sadri: ['base', 'collar'],
  vest: ['base', 'lapel'],
};

const FILTER_CATEGORIES = [
  { id: 'suits', label: 'Suit', icon: 'SUI', cloths: ['coat', 'vest', 'shirt'] },
  { id: 'formal', label: 'Formal', icon: 'FOR', cloths: ['shirt'] },
  { id: 'kurta', label: 'Kurta', icon: 'KUR', cloths: ['kurta', 'sadri', 'coat'] },
];

const GARMENT_OPTIONS = [
  { id: 'coat', label: 'Coat' },
  { id: 'vest', label: 'Vest Coat' },
  { id: 'shirt', label: 'Shirt' },
  { id: 'kurta', label: 'Kurta' },
  { id: 'sadri', label: 'Sadri' },
];

const CATEGORY_LABELS = FILTER_CATEGORIES.reduce((acc, category) => {
  acc[category.id] = category.label;
  return acc;
}, {});

const GARMENT_LABELS = GARMENT_OPTIONS.reduce((acc, garment) => {
  acc[garment.id] = garment.label;
  return acc;
}, {});

const EMBROIDERY_ITEMS = GARMENT_OPTIONS.reduce((acc, garment) => {
  acc[garment.id] = FILTER_CATEGORIES
    .filter((category) => category.cloths.includes(garment.id))
    .map((category) => category.id);
  return acc;
}, {});

const formatLabel = (value) => String(value || '').replace(/[_-]+/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

const formatCategoryLabel = (value) => CATEGORY_LABELS[normalizeKey(value)] || formatLabel(value);

const formatGarmentLabel = (value) => GARMENT_LABELS[normalizeKey(value)] || formatLabel(value);

const getPartsForGarment = (garmentType) => GARMENT_PARTS[normalizeKey(garmentType)] || ['base'];

const formatPartLabel = (value) => formatLabel(value);

const getEmbroideryBaseRef = ({ category, garmentType }) => {
  const cat = normalizeKey(category);
  const type = normalizeKey(garmentType);
  return db.collection('Fabric').doc('embroidery').collection(cat).doc(type);
};

const EmbroideryForm = () => {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [resourceImages, setResourceImages] = useState([]);
  const [resourcePreviews, setResourcePreviews] = useState([]);
  const [targetType, setTargetType] = useState('coat');
  const [targetCategory, setTargetCategory] = useState(EMBROIDERY_ITEMS.coat[0]);
  const [targetPart, setTargetPart] = useState(getPartsForGarment('coat')[0]);
  const [selectedEmbStyle, setSelEmbStyle] = useState('');

  const [targetTypeOpen, setTargetTypeOpen] = useState(false);
  const [targetCategoryOpen, setTargetCategoryOpen] = useState(false);
  const [targetPartOpen, setTargetPartOpen] = useState(false);
  const targetTypeRef = useRef(null);
  const targetCategoryRef = useRef(null);
  const targetPartRef = useRef(null);

  useEffect(() => {
    const allowedCategories = EMBROIDERY_ITEMS[targetType] || [];
    if (!allowedCategories.includes(targetCategory) && allowedCategories.length > 0) {
      setTargetCategory(allowedCategories[0]);
    }
  }, [targetType, targetCategory]);

  useEffect(() => {
    const allowedParts = getPartsForGarment(targetType);
    if (!allowedParts.includes(targetPart) && allowedParts.length > 0) {
      setTargetPart(allowedParts[0]);
    }
  }, [targetType, targetPart]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (targetTypeRef.current && !targetTypeRef.current.contains(event.target)) setTargetTypeOpen(false);
      if (targetCategoryRef.current && !targetCategoryRef.current.contains(event.target)) setTargetCategoryOpen(false);
      if (targetPartRef.current && !targetPartRef.current.contains(event.target)) setTargetPartOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const embroideryType = `${targetType}_${targetPart}`;

  const [pocketHidden, setPocketHidden] = useState(false);

  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [styleSearch, setStyleSearch] = useState('');
  const [styleTypeFilter, setStyleTypeFilter] = useState('all');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadTotal, setUploadTotal] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('');
  const [successModal, setSuccessModal] = useState(null);
  const [deletingUpload, setDeletingUpload] = useState(false);

  const [embroidery_style, setEmbroideryStyle] = useState([]);
  const [uploadedRenders, setUploadedRenders] = useState([]);
  const [renderListSearch, setRenderListSearch] = useState('');
  const [renderListGarmentFilter, setRenderListGarmentFilter] = useState(() => FILTER_CATEGORIES[0].cloths[0]);
  const [renderListCategoryFilter, setRenderListCategoryFilter] = useState(() => FILTER_CATEGORIES[0].id);
  const [renderListPartFilter, setRenderListPartFilter] = useState(() => getPartsForGarment(FILTER_CATEGORIES[0].cloths[0])[0]);
  const [editingItem, setEditingItem] = useState(null);
  const [editExistingResources, setEditExistingResources] = useState(null);
  const [deleteConfirmItem, setDeleteConfirmItem] = useState(null);
  const [deletingCard, setDeletingCard] = useState(false);
  const currentRenderCategory = FILTER_CATEGORIES.find((cat) => cat.id === renderListCategoryFilter) || FILTER_CATEGORIES[0];

  useEffect(() => {
    const allowedCloths = currentRenderCategory?.cloths || [];
    if (!allowedCloths.length || allowedCloths.includes(renderListGarmentFilter)) return;
    setRenderListGarmentFilter(allowedCloths[0]);
  }, [currentRenderCategory, renderListGarmentFilter]);

  useEffect(() => {
    const allowedParts = getPartsForGarment(renderListGarmentFilter);
    if (!allowedParts.includes(renderListPartFilter) && allowedParts.length > 0) {
      setRenderListPartFilter(allowedParts[0]);
    }
  }, [renderListGarmentFilter, renderListPartFilter]);

  const loadUploadedRenders = async () => {
    try {
      const cat = normalizeKey(renderListCategoryFilter);
      const garmentType = normalizeKey(renderListGarmentFilter);
      const part = normalizeKey(renderListPartFilter);
      if (!cat || !garmentType) {
        setUploadedRenders([]);
        return;
      }

      const baseRef = getEmbroideryBaseRef({ category: cat, garmentType });
      const data = await getData(baseRef.collection('embroideries'));
      const filtered = (data || [])
        .map((item) => ({
          ...item,
          _category: cat,
          _garmentType: garmentType,
          _part: normalizeKey(item.targetPart),
        }))
        .filter((item) => normalizeKey(item.targetPart) === part)
        .sort((a, b) => {
        const ai = Number(a.id) || 0;
        const bi = Number(b.id) || 0;
        return bi - ai;
        });

      setUploadedRenders(filtered);
    } catch (err) {
      console.log('Failed to load uploaded embroidery renders:', err);
    }
  };

  useEffect(() => {
    const coll_ref = db.collection("Fabric").doc("embroidery").collection("styles");
    getData(coll_ref).then((emb) => { setEmbroideryStyle(emb || []); });
  }, []);

  useEffect(() => {
    loadUploadedRenders();
  }, [renderListCategoryFilter, renderListGarmentFilter, renderListPartFilter]);

  const handleResourceImagesChange = (e) => {
    const files = Array.from(e.target.files);
    setResourceImages((prev) => [...prev, ...files]);
    setResourcePreviews((prev) => [...prev, ...files.map((f) => URL.createObjectURL(f))]);
  };

  const removeResourceImage = (index) => {
    setResourceImages((prev) => prev.filter((_, i) => i !== index));
    setResourcePreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const cancelEdit = () => {
    setEditingItem(null);
    setEditExistingResources(null);
    setName('');
    setPrice('');
    setResourceImages([]);
    setResourcePreviews([]);
    setSelEmbStyle('');
    setPocketHidden(false);
  };

  const startEdit = (item) => {
    const nextType = normalizeKey(item.targetType) || 'coat';
    setEditingItem({ ...item });
    setEditExistingResources(item.resources && typeof item.resources === 'object' ? { ...item.resources } : {});
    setName(item.name || '');
    setPrice(item.price != null ? String(item.price) : '');
    setTargetType(nextType);
    setTargetCategory(normalizeKey(item.targetCategory) || EMBROIDERY_ITEMS[nextType]?.[0] || FILTER_CATEGORIES[0].id);
    setTargetPart(normalizeKey(item.targetPart) || getPartsForGarment(nextType)[0]);
    const st = item.style != null ? styleById[item.style] : null;
    setSelEmbStyle(st || '');
    setResourceImages([]);
    setResourcePreviews([]);
    setPocketHidden(item.pocketHidden === true);
    setTargetTypeOpen(false);
    setTargetCategoryOpen(false);
    setTargetPartOpen(false);
  };

  const removeExistingEditResource = (key) => {
    setEditExistingResources((prev) => {
      if (!prev || !(key in prev)) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const deleteRenderEntry = async (item) => {
    const id = item.id || item.doc;
    const cat = normalizeKey(item.targetCategory || item._category);
    const garmentType = normalizeKey(item.targetType || item._garmentType);
    const part = normalizeKey(item.targetPart || item._part);
    if (!id || !cat || !garmentType || !part) return;
    const urls = Object.values(item.resources || {});
    const keys = Object.keys(item.resources || {});
    await Promise.all(urls.map((url) => deleteFileByUrl(url)));
    const baseRef = getEmbroideryBaseRef({ category: cat, garmentType });
    const coll_ref = baseRef.collection('embroideries');
    const styleRef = coll_ref.doc(id).collection('style');
    await Promise.all(keys.map((k) => styleRef.doc(k).delete()));
    await coll_ref.doc(id).delete();
  };

  const handleDeleteFromList = async () => {
    if (!deleteConfirmItem) return;
    try {
      setDeletingCard(true);
      await deleteRenderEntry(deleteConfirmItem);
      setDeleteConfirmItem(null);
      if (editingItem && (editingItem.id === deleteConfirmItem.id || editingItem.doc === deleteConfirmItem.doc)) {
        cancelEdit();
      }
      loadUploadedRenders();
    } catch (err) {
      console.log('delete embroidery render from list', err);
      alert('Unable to delete this render.');
    } finally {
      setDeletingCard(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name) { alert('Name is required.'); return; }
    if (!targetType || !targetCategory || !targetPart) { alert('Please select Garment Type, Outfit Category, and Garment Part.'); return; }
    if (!selectedEmbStyle || (typeof selectedEmbStyle === 'string' && selectedEmbStyle.length === 0)) { alert('Embroidery Style is required'); return; }

    const isEdit = !!editingItem;
    const existingCount = isEdit && editExistingResources ? Object.keys(editExistingResources).length : 0;
    if (!isEdit && resourceImages.length === 0) { alert('At least one render image is required.'); return; }
    if (isEdit && resourceImages.length === 0 && existingCount === 0) { alert('Keep at least one render image, or add new files.'); return; }

    const total = (resourceImages?.length || 0);
    setUploadTotal(total || 1);
    setUploadProgress(0);
    setLoading(true);

    try {
      if (isEdit) {
        const id = String(editingItem.id || editingItem.doc);
        const oldCat = normalizeKey(editingItem.targetCategory || editingItem._category);
        const oldType = normalizeKey(editingItem.targetType || editingItem._garmentType);
        const oldPart = normalizeKey(editingItem.targetPart || editingItem._part);
        const newCat = normalizeKey(targetCategory);
        const newType = normalizeKey(targetType);
        const newPart = normalizeKey(targetPart);

        const oldBase = getEmbroideryBaseRef({ category: oldCat, garmentType: oldType });
        const newBase = getEmbroideryBaseRef({ category: newCat, garmentType: newType });
        const coll_ref_new = newBase.collection('embroideries');
        const coll_ref_old = oldBase.collection('embroideries');

        const originalResources = editingItem.resources && typeof editingItem.resources === 'object' ? { ...editingItem.resources } : {};
        const keptResources = editExistingResources && typeof editExistingResources === 'object' ? { ...editExistingResources } : {};
        const removedKeys = Object.keys(originalResources).filter((k) => !(k in keptResources));

        setUploadStatus('Removing deleted images...');
        for (const k of removedKeys) {
          const url = originalResources[k];
          if (url) await deleteFileByUrl(url);
          if (oldCat === newCat && oldType === newType && oldPart === newPart) {
            await coll_ref_old.doc(id).collection('style').doc(k).delete();
          }
        }

        setUploadStatus('Uploading new render images...');
        const resource_urls = { ...keptResources };
        for (let i = 0; i < resourceImages.length; i++) {
          const storageBase = `Embroidery/${id}/${newType}_${newPart}`;
          const baseKey = `${resourceImages[i].name.replace(' ', '').split('.')[0]}`;
          let docKey = baseKey;
          let n = 0;
          while (docKey in resource_urls) {
            n += 1;
            docKey = `${baseKey}_${n}`;
          }
          const url = await handleFireBaseUpload(`${id}_resource_${Date.now()}_${i}`, resourceImages[i], storageBase);
          resource_urls[docKey] = url;
          setUploadProgress((p) => p + 1);
        }

        setUploadStatus('Saving to database...');
        const parentPayload = {
          id,
          name,
          price: Number(price) || 0,
          resources: resource_urls,
          style: selectedEmbStyle.id,
          type: selectedEmbStyle.type,
          targetType: newType,
          targetCategory: newCat,
          targetPart: newPart,
          pocketHidden,
          ...(editingItem.created ? { created: editingItem.created } : {}),
        };

        if (!(oldCat === newCat && oldType === newType)) {
          const newDocRef = coll_ref_new.doc(id);
          const batch = db.batch();
          Object.keys(resource_urls).forEach((doc1) => {
            batch.set(newDocRef.collection('style').doc(doc1), { src: resource_urls[doc1] });
          });
          batch.set(newDocRef, parentPayload);
          await batch.commit();

          const oldDocRef = coll_ref_old.doc(id);
          const oldStyleSnap = await oldDocRef.collection('style').get();
          const delBatch = db.batch();
          oldStyleSnap.forEach((d) => delBatch.delete(d.ref));
          delBatch.delete(oldDocRef);
          await delBatch.commit();
        } else {
          const styleRef = coll_ref_new.doc(id).collection('style');
          const batch = db.batch();
          Object.keys(resource_urls).forEach((doc1) => {
            batch.set(styleRef.doc(doc1), { src: resource_urls[doc1] });
          });
          await batch.commit();
          await updateDoc(coll_ref_new, id, parentPayload);
        }

        setSuccessModal({
          id,
          name,
          embroideryType: `${newType}_${newPart}`,
          targetType: newType,
          targetCategory: newCat,
          targetPart: newPart,
          styleName: selectedEmbStyle?.name || '-',
          price: Number(price) || 0,
          resourcesCount: Object.keys(resource_urls).length,
          resourceUrls: Object.values(resource_urls),
          resourceKeys: Object.keys(resource_urls),
          isUpdate: true,
        });

        cancelEdit();
        loadUploadedRenders();
      } else {
        const id = new Date().getTime().toString();
        const newCat = normalizeKey(targetCategory);
        const newType = normalizeKey(targetType);
        const newPart = normalizeKey(targetPart);
        const storageBase = `Embroidery/${id}/${newType}_${newPart}`;

        setUploadStatus('Uploading render images...');
        const resource_urls = {};
        for (let i = 0; i < resourceImages.length; i++) {
          const url = await handleFireBaseUpload(`${id}_resource_${i}`, resourceImages[i], storageBase);
          resource_urls[`${resourceImages[i].name.replace(' ', '').split('.')[0]}`] = url;
          setUploadProgress((p) => p + 1);
        }

        setUploadStatus('Saving to database...');
        const baseRef = getEmbroideryBaseRef({ category: newCat, garmentType: newType });
        const coll_ref = baseRef.collection('embroideries');
        const styleRef = coll_ref.doc(id).collection('style');

        var batch = db.batch();
        Object.keys(resource_urls).forEach((doc1) => {
          var docRef = styleRef.doc(doc1);
          batch.set(docRef, { src: resource_urls[doc1] });
        });
        await batch.commit();

        await addData(coll_ref, id, {
          id,
          name,
          price: Number(price) || 0,
          resources: resource_urls,
          style: selectedEmbStyle.id,
          type: selectedEmbStyle.type,
          targetType: newType,
          targetCategory: newCat,
          targetPart: newPart,
          pocketHidden,
        });

        setSuccessModal({
          id,
          name,
          embroideryType: `${newType}_${newPart}`,
          targetType: newType,
          targetCategory: newCat,
          targetPart: newPart,
          styleName: selectedEmbStyle?.name || '-',
          price: Number(price) || 0,
          resourcesCount: Object.keys(resource_urls).length,
          resourceUrls: Object.values(resource_urls),
          resourceKeys: Object.keys(resource_urls),
          isUpdate: false,
        });

        setName('');
        setPrice('');
        setResourceImages([]);
        setResourcePreviews([]);
        setSelEmbStyle('');
        loadUploadedRenders();
      }
    } catch (err) {
      console.log('Embroidery render upload failed:', err);
      alert(isEdit ? 'Update failed. Please try again.' : 'Upload failed. Please try again.');
    } finally {
      setLoading(false);
      setUploadStatus('');
    }
  };

  const deleteUploadedEmbroideryRender = async () => {
    if (!successModal) return;
    try {
      setDeletingUpload(true);
      const urls = [
        ...(successModal.resourceUrls || []),
      ];
      await Promise.all(urls.map((url) => deleteFileByUrl(url)));

      const baseRef = getEmbroideryBaseRef({ category: successModal.targetCategory, garmentType: successModal.targetType });
      const coll_ref = baseRef.collection('embroideries');
      const styleRef = coll_ref.doc(successModal.id).collection('style');
      await Promise.all((successModal.resourceKeys || []).map((k) => styleRef.doc(k).delete()));
      await coll_ref.doc(successModal.id).delete();

      setSuccessModal(null);
      loadUploadedRenders();
    } catch (error) {
      console.log('delete uploaded embroidery render', error);
      alert('Unable to delete the uploaded embroidery render.');
    } finally {
      setDeletingUpload(false);
    }
  };

  const filteredStyles = (embroidery_style || []).filter((val) => {
    if (styleTypeFilter !== 'all' && (val.type || '').toLowerCase() !== styleTypeFilter.toLowerCase()) return false;
    if (!styleSearch) return true;
    return JSON.stringify(val).toLowerCase().includes(styleSearch.toLowerCase());
  });

  const STYLE_TYPE_CHIPS = [
    { key: 'all', label: 'All' },
    { key: 'Machine work', label: 'Machine work' },
    { key: 'Handwork', label: 'Handwork' },
    { key: 'Hand & Machine Mix', label: 'Hand & Machine Mix' },
  ];

  const styleById = React.useMemo(() => {
    const m = {};
    (embroidery_style || []).forEach((s) => {
      if (s && s.id != null) m[s.id] = s;
    });
    return m;
  }, [embroidery_style]);

  const renderThumb = (item) => {
    const res = item.resources;
    if (res && typeof res === 'object' && Object.keys(res).length) {
      return Object.values(res)[0];
    }
    return null;
  };

  const filteredUploadedRenders = (uploadedRenders || []).filter((item) => {
    if (!renderListSearch) return true;
    return JSON.stringify(item).toLowerCase().includes(renderListSearch.toLowerCase());
  });

  return (
    <div className="button_upload_page button-upload-premium-page embroidery-render-page">
      <div className="button_upload_form fabric-modern button-upload-premium-form">
        {editingItem && (
          <div className="embroidery-render-edit-banner">
            <div>
              <strong>Editing render</strong>
              <span>{editingItem.name || editingItem.id} · {editingItem._typeKey}</span>
            </div>
            <button type="button" className="embroidery-render-edit-cancel" onClick={cancelEdit}>
              Cancel edit
            </button>
          </div>
        )}
        <form onSubmit={handleSubmit} className="button-upload-premium-fields">
          <div className="f-inputs">
            <label className="button-upload-label">Name <span className="text-red-500">*</span></label>
            <input type="text" placeholder="Enter render name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>

          <div className="f-inputs">
            <label className="button-upload-label">Price</label>
            <input type="number" placeholder="0" value={price} onChange={(e) => setPrice(e.target.value)} min="0" />
          </div>

          <div className="f-inputs" ref={targetTypeRef}>
            <label className="button-upload-label">Garment Type <span className="text-red-500">*</span></label>
            <div className="fabric-custom-select">
              <button type="button" className="fabric-custom-select-trigger" onClick={() => setTargetTypeOpen((v) => !v)}>
                <span>{formatGarmentLabel(targetType)}</span>
                <span className={`fabric-custom-select-arrow ${targetTypeOpen ? 'open' : ''}`}>▾</span>
              </button>
              {targetTypeOpen && (
                <div className="fabric-custom-select-menu">
                  {GARMENT_OPTIONS.map((garment) => (
                    <button type="button" key={garment.id} className={`fabric-custom-select-option ${targetType === garment.id ? 'active' : ''}`} onClick={() => { setTargetType(garment.id); setTargetTypeOpen(false); }}>{garment.label}</button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="f-inputs" ref={targetCategoryRef}>
            <label className="button-upload-label">Outfit Category <span className="text-red-500">*</span></label>
            <div className="fabric-custom-select">
              <button type="button" className="fabric-custom-select-trigger" onClick={() => setTargetCategoryOpen((v) => !v)}>
                <span>{formatCategoryLabel(targetCategory)}</span>
                <span className={`fabric-custom-select-arrow ${targetCategoryOpen ? 'open' : ''}`}>▾</span>
              </button>
              {targetCategoryOpen && (
                <div className="fabric-custom-select-menu">
                  {(EMBROIDERY_ITEMS[targetType] || []).map((categoryId) => (
                    <button type="button" key={categoryId} className={`fabric-custom-select-option ${targetCategory === categoryId ? 'active' : ''}`} onClick={() => { setTargetCategory(categoryId); setTargetCategoryOpen(false); }}>{formatCategoryLabel(categoryId)}</button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="f-inputs" ref={targetPartRef}>
            <label className="button-upload-label">Garment Part <span className="text-red-500">*</span></label>
            <div className="fabric-custom-select">
              <button type="button" className="fabric-custom-select-trigger" onClick={() => setTargetPartOpen((v) => !v)}>
                <span>{formatPartLabel(targetPart)}</span>
                <span className={`fabric-custom-select-arrow ${targetPartOpen ? 'open' : ''}`}>▾</span>
              </button>
              {targetPartOpen && (
                <div className="fabric-custom-select-menu">
                  {getPartsForGarment(targetType).map((part) => (
                    <button type="button" key={part} className={`fabric-custom-select-option ${targetPart === part ? 'active' : ''}`} onClick={() => { setTargetPart(part); setTargetPartOpen(false); }}>{formatPartLabel(part)}</button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {targetPart === 'base' && (
            <div className="f-inputs">
              <label className="button-upload-label">Pocket</label>
              <div className="embroidery-collection-pocket-toggle">
                <span className="embroidery-collection-pocket-label">Pocket</span>
                <label className="emb-pocket-switch">
                  <input
                    type="checkbox"
                    checked={!pocketHidden}
                    onChange={(e) => setPocketHidden(!e.target.checked)}
                  />
                  <span className="emb-pocket-slider"></span>
                </label>
                <span className="emb-pocket-status">{pocketHidden ? 'Hidden' : 'Visible'}</span>
              </div>
            </div>
          )}

          <div className="f-inputs">
            <label className="button-upload-label">Embroidery Style <span className="text-red-500">*</span></label>
            <div className={`outfit-inline-fabric-select ${selectedEmbStyle && selectedEmbStyle.id ? 'outfit-inline-fabric-select-active' : ''}`}>
              {selectedEmbStyle && selectedEmbStyle.id ? (
                <div className="outfit-inline-fabric-value">
                  <img src={selectedEmbStyle.src} alt={selectedEmbStyle.name} />
                  <div className="outfit-inline-fabric-copy">
                    <strong>{selectedEmbStyle.name}</strong>
                    <span>{selectedEmbStyle.type ? `${selectedEmbStyle.type} work` : '-'}</span>
                    <small>Click Change to pick another style</small>
                  </div>
                  <div className="button-fabric-picker-actions">
                    <button type="button" className="outfit-inline-fabric-remove" onClick={() => setModal(true)}>Change</button>
                    <button type="button" className="outfit-inline-fabric-remove button-fabric-picker-clear" onClick={() => setSelEmbStyle('')}>Remove</button>
                  </div>
                </div>
              ) : (
                <button type="button" className="button-fabric-picker-trigger" onClick={() => setModal(true)}>
                  <span className="button-fabric-picker-trigger-label">Select embroidery style</span>
                  <span className="button-fabric-picker-trigger-arrow">›</span>
                </button>
              )}
            </div>
          </div>

          <div className="f-inputs">
            <div className="fabric-file-title">
              <b>{editingItem ? 'Add more render images (optional)' : 'Upload Render'} {!editingItem && <span className="text-red-500">*</span>}</b>
            </div>
            {editingItem && editExistingResources && Object.keys(editExistingResources).length > 0 && (
              <div className="embroidery-render-existing-files">
                <span className="embroidery-render-existing-label">Current files — remove any you want to delete on save</span>
                <div className="tuxedo-inline-previews">
                  {Object.entries(editExistingResources).map(([key, url]) => (
                    <div className="tuxedo-inline-preview-item" key={`exist-${key}`}>
                      <img src={url} alt={key} />
                      <button type="button" className="tuxedo-inline-remove" onClick={() => removeExistingEditResource(key)} aria-label={`Remove ${key}`}>
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <input
              className="fabric-file-input"
              type="file"
              accept="image/*"
              multiple
              onChange={handleResourceImagesChange}
              required={!editingItem}
            />
            {resourcePreviews.length > 0 && (
              <div className="tuxedo-inline-previews">
                {resourcePreviews.map((preview, idx) => (
                  <div className="tuxedo-inline-preview-item" key={`res-${idx}`}>
                    <img src={preview} alt={`render-${idx}`} />
                    <button type="button" className="tuxedo-inline-remove" onClick={() => removeResourceImage(idx)} aria-label="Remove">×</button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {loading ? (
            <div className="outfit-upload-progress">
              <div className="outfit-upload-progress-top">
                <span>{uploadStatus || 'Uploading...'}</span>
                <strong>{uploadTotal ? Math.floor((uploadProgress / uploadTotal) * 100) : 0}%</strong>
              </div>
              <div className="outfit-upload-progress-track">
                <div
                  className="outfit-upload-progress-fill"
                  style={{ width: `${uploadTotal ? (uploadProgress / uploadTotal) * 100 : 0}%` }}
                />
              </div>
              <div className="outfit-upload-progress-meta">
                {uploadProgress} / {uploadTotal} files uploaded
              </div>
            </div>
          ) : (
            <button type="submit" className="fabric-submit-btn">
              {editingItem ? 'Update embroidery render' : 'Upload Embroidery Render'}
            </button>
          )}
        </form>
      </div>

      <div className="button-upload-list-shell">
        <h2 className="button-upload-list-title">Uploaded embroidery renders</h2>
        <div className="edit-fabric-filterbar edit-outfit-filterbar edit-outfit-filterbar-v2 embroidery-render-list-filterbar">
          <div className="edit-outfit-filter-row edit-outfit-filter-row-top">
            <div className="edit-outfit-category-tabs">
              {FILTER_CATEGORIES.map((cat) => (
                <button
                  key={cat.id}
                  type="button"
                  className={`edit-outfit-cat-tab ${renderListCategoryFilter === cat.id ? 'active' : ''}`}
                  onClick={() => {
                    setRenderListCategoryFilter(cat.id);
                    setRenderListGarmentFilter(cat.cloths[0] || 'coat');
                    setRenderListPartFilter(getPartsForGarment(cat.cloths[0] || 'coat')[0]);
                  }}
                >
                  <span className="edit-outfit-cat-tab-icon">{cat.icon}</span>
                  <span className="edit-outfit-cat-tab-label">{cat.label}</span>
                </button>
              ))}
            </div>

            <div className="edit-outfit-filter-divider" />

            <div className="edit-outfit-cloth-chips">
              {(currentRenderCategory?.cloths || []).map((cloth) => (
                <button
                  key={cloth}
                  type="button"
                  className={`edit-outfit-chip ${renderListGarmentFilter === cloth ? 'active' : ''}`}
                  onClick={() => setRenderListGarmentFilter(cloth)}
                >
                  {formatGarmentLabel(cloth)}
                </button>
              ))}
            </div>
          </div>

          <div className="edit-outfit-filter-row edit-outfit-filter-row-top">
            <div className="edit-outfit-cloth-chips embroidery-render-part-chips">
              {getPartsForGarment(renderListGarmentFilter).map((part) => (
                <button
                  key={part}
                  type="button"
                  className={`edit-outfit-chip ${renderListPartFilter === part ? 'active' : ''}`}
                  onClick={() => setRenderListPartFilter(part)}
                >
                  {formatPartLabel(part)}
                </button>
              ))}
            </div>

            <div className="edit-outfit-search-box edit-outfit-search-box-v2 embroidery-render-filter-search">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input
                className="search_fabric_clothes"
                placeholder="Search renders (name, style, part)"
                value={renderListSearch}
                onChange={(e) => setRenderListSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="button_uploads button-upload-list">
          {filteredUploadedRenders.length === 0 ? (
            <div className="add-brand-empty">No embroidery renders uploaded yet.</div>
          ) : (
            filteredUploadedRenders.map((item, i) => {
              const thumb = renderThumb(item);
              const linkedStyle = item.style != null ? styleById[item.style] : null;
              const renderCount = item.resources && typeof item.resources === 'object' ? Object.keys(item.resources).length : 0;
              const displayCategory = item.targetCategory ? formatCategoryLabel(item.targetCategory) : (item._category ? formatCategoryLabel(item._category) : '-');
              const displayGarment = item.targetType ? formatGarmentLabel(item.targetType) : (item._garmentType ? formatGarmentLabel(item._garmentType) : '-');
              const displayPart = item.targetPart ? formatPartLabel(item.targetPart) : '-';
              return (
                <div className="button_upload_card button-upload-premium-card" key={`${item._category || item.targetCategory}-${item._garmentType || item.targetType}-${item.id || i}`}>
                  <div className="button-upload-card-actions">
                    <button type="button" className="button-upload-edit-icon-btn" onClick={() => startEdit(item)} aria-label="Edit embroidery render">
                      ✎
                    </button>
                    <button type="button" className="button-upload-edit-icon-btn button-upload-delete-icon-btn" onClick={() => setDeleteConfirmItem(item)} aria-label="Delete embroidery render">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polyline points="3 6 5 6 21 6" />
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                        <path d="M10 11v6M14 11v6" />
                        <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                      </svg>
                    </button>
                  </div>
                  <div className="button-upload-card-image-wrap">
                    {thumb ? (
                      <img src={thumb} alt={item.name || 'Render'} className="button-upload-card-image" />
                    ) : (
                      <div className="button-upload-card-image-fallback" aria-hidden>—</div>
                    )}
                  </div>
                  <div className="button-upload-card-details">
                    <div className="button-upload-card-name" title={item.name || '-'}>{item.name || 'Untitled'}</div>
                    <div className="button-upload-card-specs">
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Outfit category</span>
                        <span className="button-upload-spec-value">{displayCategory}</span>
                      </div>
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Garment</span>
                        <span className="button-upload-spec-value">{displayGarment}</span>
                      </div>
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Part</span>
                        <span className="button-upload-spec-value">{displayPart}</span>
                      </div>
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Style</span>
                        <span className="button-upload-spec-value">{linkedStyle?.name || '-'}</span>
                      </div>
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Price</span>
                        <span className="button-upload-spec-value">{Number(item.price) || 0}</span>
                      </div>
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Work type</span>
                        <span className="button-upload-spec-value">{linkedStyle?.type || item.type || '-'}</span>
                      </div>
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Renders</span>
                        <span className="button-upload-spec-value">{renderCount}</span>
                      </div>
                      <div className="button-upload-spec-row">
                        <span className="button-upload-spec-label">Bucket</span>
                        <span className="button-upload-spec-value embroidery-render-type-key" title={`${item.targetCategory || item._category}/${item.targetType || item._garmentType}`}>{`${item.targetCategory || item._category}/${item.targetType || item._garmentType}`}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {deleteConfirmItem && (
        <div className="outfit-success-modal-backdrop" onClick={() => !deletingCard && setDeleteConfirmItem(null)}>
          <div className="outfit-success-modal" onClick={(ev) => ev.stopPropagation()}>
            <div className="outfit-success-modal-badge outfit-success-modal-badge-danger">Confirm Delete</div>
            <h3>Delete this embroidery render?</h3>
            <div className="outfit-success-modal-grid">
              <div><span>Name</span><strong>{deleteConfirmItem.name || '-'}</strong></div>
              <div><span>Bucket</span><strong className="embroidery-render-type-key">{deleteConfirmItem._typeKey || '-'}</strong></div>
              <div><span>Renders</span><strong>{Object.keys(deleteConfirmItem.resources || {}).length}</strong></div>
            </div>
            <button type="button" className="fabric-submit-btn outfit-success-close" onClick={() => setDeleteConfirmItem(null)} disabled={deletingCard}>
              Cancel
            </button>
            <button type="button" className="fabric-submit-btn outfit-delete-close" onClick={handleDeleteFromList} disabled={deletingCard}>
              {deletingCard ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </div>
      )}

      {modal && (
        <div className="recom-modal-backdrop" onClick={() => setModal(false)}>
          <div className="recom-modal embroidery-style-picker-modal" onClick={(ev) => ev.stopPropagation()}>
            <div className="recom-modal-header">
              <div>
                <h3>Select Embroidery Style</h3>
                <p>Pick a style to link with this render. {filteredStyles.length} style{filteredStyles.length === 1 ? '' : 's'} available.</p>
              </div>
              <button type="button" className="recom-modal-close" onClick={() => setModal(false)} aria-label="Close">×</button>
            </div>
            <div className="recom-modal-filterbar">
              <div className="recom-modal-chips">
                {STYLE_TYPE_CHIPS.map((chip) => (
                  <button
                    type="button"
                    key={chip.key}
                    className={`recom-modal-chip ${styleTypeFilter === chip.key ? 'active' : ''}`}
                    onClick={() => setStyleTypeFilter(chip.key)}
                  >
                    {chip.label}
                  </button>
                ))}
              </div>
              <div className="recom-modal-search">
                <input type="text" placeholder="Search style" value={styleSearch} onChange={(e) => setStyleSearch(e.target.value)} />
                <img src={sh} alt="Search" />
              </div>
            </div>
            <div className="recom-modal-body">
              {filteredStyles.length === 0 ? (
                <div className="recom-modal-empty">No embroidery styles found.</div>
              ) : (
                <div className="recom-modal-grid">
                  {filteredStyles.map((val) => {
                    const isSelected = selectedEmbStyle && selectedEmbStyle.id === val.id;
                    return (
                      <div
                        key={val.id}
                        className={`recom-button-card ${isSelected ? 'selected' : ''}`}
                        onClick={() => { setSelEmbStyle(val); setModal(false); }}
                      >
                        <div className="recom-button-card-image-wrap">
                          <img src={val.src} alt={val.name || 'Style'} className="recom-button-card-image" />
                          {isSelected && (<span className="recom-button-card-check" aria-hidden>✓</span>)}
                        </div>
                        <div className="recom-button-card-details">
                          <div className="recom-button-card-name" title={val.name || '-'}>{val.name || 'Untitled'}</div>
                          <div className="recom-button-card-specs">
                            <div className="recom-button-spec-row">
                              <span className="recom-button-spec-label">Type</span>
                              <span className="recom-button-spec-value">{val.type || '-'}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {successModal && (
        <div className="outfit-success-modal-backdrop">
          <div className="outfit-success-modal">
            <div className="outfit-success-modal-badge">{successModal.isUpdate ? 'Updated' : 'Upload Successful'}</div>
            <h3>{successModal.isUpdate ? 'Embroidery render updated successfully' : 'Embroidery render uploaded successfully'}</h3>
            <div className="outfit-success-modal-grid">
              <div><span>ID</span><strong>{successModal.id}</strong></div>
              <div><span>Name</span><strong>{successModal.name}</strong></div>
              <div><span>Price</span><strong>{successModal.price}</strong></div>
              <div><span>Garment Type</span><strong>{formatGarmentLabel(successModal.targetType)}</strong></div>
              <div><span>Outfit Category</span><strong>{formatCategoryLabel(successModal.targetCategory)}</strong></div>
              <div><span>Garment Part</span><strong>{formatPartLabel(successModal.targetPart)}</strong></div>
              <div><span>Style</span><strong>{successModal.styleName}</strong></div>
              <div><span>Renders</span><strong>{successModal.resourcesCount}</strong></div>
            </div>
            <button type="button" className="fabric-submit-btn outfit-success-close" onClick={() => setSuccessModal(null)}>
              Close
            </button>
            <button
              type="button"
              className="fabric-submit-btn outfit-delete-close"
              onClick={() => {
                if (deletingUpload) return;
                if (window.confirm(`Are you sure you want to delete ${successModal?.name || 'this uploaded embroidery render'}? This action cannot be undone.`)) {
                  deleteUploadedEmbroideryRender();
                }
              }}
              disabled={deletingUpload}
            >
              {deletingUpload ? 'Deleting...' : 'Delete This Upload'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmbroideryForm;
